<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          class="full-width"
          ><div slot="header">
            <strong>View FAQ</strong>
            <eb-button
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('view', e)"
            ></eb-button>
          </div>

          <!-- <div slot="header">
            <span data-font="22">Create FAQ</span>
          </div>-->
          <b-row v-if="userRole === 'Tenant'">
            <b-col sm="6">
              <b-form-group label="Scope" label-for="Scope" :label-cols="3">
                <b-form-input
                  type="text"
                  id="scope"
                  placeholder="Scope"
                  v-model="itemObj.scope"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Category"
                label-for="Category"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="category"
                  v-model="itemObj.category"
                  placeholder="Category"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Topic" label-for="Topic" :label-cols="3">
                <b-form-input
                  type="text"
                  id="topic"
                  placeholder="Topic"
                  v-model="itemObj.Topic"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Description"
                label-for="Description"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="description"
                  placeholder="Description"
                  v-model="itemObj.Description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="MediaType"
                label-for="MediaType"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="mediatype"
                  placeholder="MediaType"
                  v-model="itemObj.mediaType"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-row class="ml-1">
              <b-col
                sm="6"
                v-if="
                  itemObj.mediaType === 'IMAGE' ||
                  itemObj.mediaType === 'VIDEO' ||
                  itemObj.mediaType === 'DOCUMENT'
                "
              >
                <b-form-group
                  class="m-0"
                  label="Media Content"
                  label-for="SmallImage"
                  :label-cols="7"
                  :horizontal="true"
                ></b-form-group>
                <div>
                  <img
                    :src="itemObj.mediaContent"
                    style="height: 200px; width: 450px"
                  />
                </div>
              </b-col>
            </b-row>
          </b-row>
          <b-row>
            <b-col md="6">
              <!-- <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="e => $emit('view', e)"
              ></eb-button> -->
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";

export default {
  name: "Viewfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
  },

  data: () => {
    return {};
  },
  props: {
    itemObj: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
